<script setup lang="ts">
import { Icon, type IconProps } from '@iconify/vue';
import type { Type } from '@varlet/ui';
import { computed, type FunctionalComponent } from 'vue';

import { resolveIcon } from './resolve';
import { type IconName } from './types';

// eslint-disable-next-line vue/define-props-destructuring
const props = defineProps<Omit<IconProps, 'icon'> & { name: IconName; type?: Type }>();

const getColor = (): string | undefined => (props.type ? `var(--color-${props.type})` : undefined);

const prepareProps = (): Omit<IconProps, 'icon'> => {
  const preparedProps = { ...props };

  if (props.type) {
    preparedProps.color = getColor();
    delete preparedProps.type;
  }

  return preparedProps;
};

const iconComponent = computed<FunctionalComponent | null>(() => resolveIcon(props.name));
</script>

<template>
  <component
    :is="iconComponent ? iconComponent : Icon"
    v-bind="prepareProps()"
    :icon="name"
  />
</template>
